export const IMAGES = {
  hero:
    "https://static.wixstatic.com/media/11062b_13af7f4b96594deba427d302c4886853~mv2.jpeg/v1/fit/w_1920,h_1080,q_90/11062b_13af7f4b96594deba427d302c4886853~mv2.jpeg",
  rigSunset:
    "https://static.wixstatic.com/media/6dca5b_eaac5aff3fa446a298efee3aed511521~mv2.jpg/v1/fit/w_1600,h_900,q_90/6dca5b_eaac5aff3fa446a298efee3aed511521~mv2.jpg",
  handshake:
    "https://static.wixstatic.com/media/6dca5b_299123715bef4ef2b9b6daa9432c6bba~mv2.jpg/v1/fill/w_1200,h_900,al_c,q_85/6dca5b_299123715bef4ef2b9b6daa9432c6bba~mv2.jpg",
  logo:
    "https://static.wixstatic.com/media/6dca5b_daf72aaa0b95458bbc1708dfaa14979e~mv2.jpg/v1/fill/w_400,h_400,al_c,q_85/6dca5b_daf72aaa0b95458bbc1708dfaa14979e~mv2.jpg",
  fuelOil:
    "https://images.unsplash.com/photo-1726731782158-fcf6822b6ca4?q=85&w=1400&auto=format&fit=crop",
  mho:
    "https://images.unsplash.com/photo-1678984240126-70bcddd7a228?q=85&w=1400&auto=format&fit=crop",
  diesel:
    "https://images.unsplash.com/photo-1629241290025-6bb716261f5f?q=85&w=1400&auto=format&fit=crop",
  pumpjack:
    "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?q=85&w=1400&auto=format&fit=crop",
  meeting:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=85&w=1600&auto=format&fit=crop",
};

export const ABOUT_LEAD =
  "At AA GULF FZE, located in the vibrant city of Dubai, we are a leading force in the energy trading industry. With a profound commitment to excellence and a deep understanding of the global energy landscape, we specialize in the trading of a diverse range of products that power industries, economies, and lives.";

export const CHAPTERS = [
  {
    num: "01",
    title: "Strategic Location",
    text: "Headquartered in Dubai — at the crossroads of East and West, hours from the world's largest energy producers and fastest-growing consumers.",
  },
  {
    num: "02",
    title: "World-Class Infrastructure",
    text: "Backed by the UAE's benchmark deep-water ports, storage terminals and logistics corridors purpose-built for energy at scale.",
  },
  {
    num: "03",
    title: "Business-Friendly Environment",
    text: "Free-zone agility: fast licensing, full foreign ownership and a regulatory framework engineered for global trade.",
  },
  {
    num: "04",
    title: "Access to Markets",
    text: "Direct reach into GCC, Asian, African and European markets through established shipping lanes and trade partnerships.",
  },
  {
    num: "05",
    title: "Diversification Opportunities",
    text: "A portfolio approach across refined products and crude — capturing value at every point of the energy chain.",
  },
  {
    num: "06",
    title: "Infrastructure for Future Growth",
    text: "Positioned inside an ecosystem investing relentlessly in the next generation of energy logistics and transition fuels.",
  },
];

export const PRODUCTS = [
  {
    code: "P-01",
    name: "Fuel Oil",
    image: IMAGES.fuelOil,
    desc: "Heavy fuel oils for power generation, marine bunkering and large-scale industrial boilers — sourced and delivered to specification.",
    specs: [
      ["Application", "Power · Marine · Industrial"],
      ["Terms", "FOB · CIF · EXW"],
      ["Origin", "Global Supply Network"],
    ],
  },
  {
    code: "P-02",
    name: "MHO",
    image: IMAGES.mho,
    desc: "Mixed Hydrocarbon Oil for furnaces, kilns and process heating — a reliable, cost-efficient industrial energy source.",
    specs: [
      ["Application", "Furnaces · Kilns · Heating"],
      ["Terms", "FOB · CIF · EXW"],
      ["Origin", "Global Supply Network"],
    ],
  },
  {
    code: "P-03",
    name: "Diesel",
    image: IMAGES.diesel,
    desc: "High-speed diesel and gas oil for transport fleets, construction and standby generation — consistent quality, on schedule.",
    specs: [
      ["Application", "Transport · Generators"],
      ["Terms", "FOB · CIF · EXW"],
      ["Origin", "Global Supply Network"],
    ],
  },
  {
    code: "P-04",
    name: "Crude Oil",
    image: IMAGES.pumpjack,
    desc: "Sourcing and trading of crude grades across international markets — connecting producers and refiners with precision.",
    specs: [
      ["Application", "Refining · Trading"],
      ["Terms", "FOB · CIF"],
      ["Origin", "Global Supply Network"],
    ],
  },
];

export const CONTACT = {
  location: "P6-ELOB Office No 5G-08, Hamriyah Free Zone, Sharjah, United Arab Emirates",
  note: "Our trading desk reviews every enquiry personally.",
};

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/contact", label: "Contact" },
];
